type BrandMarkProps = {
  size?: number;
  className?: string;
  ariaLabel?: string;
};

export function BrandMark({ size = 32, className, ariaLabel }: BrandMarkProps) {
  const a11yProps = ariaLabel
    ? { role: "img" as const, "aria-label": ariaLabel }
    : { "aria-hidden": true };

  return (
    <div
      {...a11yProps}
      style={{ width: size, height: size }}
      className={`relative inline-block rounded-full bg-slate-300 shadow-sm${
        className ? ` ${className}` : ""
      }`}
    >
      <svg
        viewBox="0 0 32 32"
        className="absolute inset-0 h-full w-full"
        fill="none"
        stroke="#000000"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M10 21 L16 11 L22 21" />
      </svg>
    </div>
  );
}
